module.exports = __webpack_public_path__ + "static/media/border-all.0b690c33.svg";